import React, { Component } from 'react';
import ErrorPage from './ErrorPage';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service
    console.error('Error caught by Error Boundary:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // Customize the fallback UI based on different errors if needed
      return <ErrorPage 
        code="500"
        title="Something went wrong"
        message="We're sorry, but an unexpected error occurred. Please try refreshing the page or returning to the home page."
      />;
    }

    // If there's no error, render children normally
    return this.props.children;
  }
}

export default ErrorBoundary; 